import cx from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '../../../common';
import { AktiiaStatusEuImage, AktiiaStatusUsImage } from '../../images';
import { IBpTypeModalProps } from './types';

enum Mode {
  EU = 'eu',
  US = 'us',
}

export const BpTypeModal = ({ name, title }: IBpTypeModalProps) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<Mode>(Mode.EU);
  const ulAfterClassNames = `after:content-[''] relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-px after:bg-border-light`;
  const liClassNames =
    'w-[64px] h-[46px] flex items-center justify-center typography-title-2 text-text-primary cursor-pointer border-b-2';
  const setEuMode = () => setMode(Mode.EU);
  const setUsMode = () => setMode(Mode.US);

  return (
    <Modal name={name} header={title}>
      <p className="typography-paragraph-3 text-text-secondary">{t(`modal.bpType.description.${mode}`)}</p>

      <ul className={cx('flex my-4', ulAfterClassNames)}>
        <li
          className={cx(liClassNames, {
            'border-global-neuchatel-50 z-10': mode === Mode.EU,
            'border-background-base-primary text-text-tertiary': mode !== Mode.EU,
          })}
          onClick={setEuMode}
        >
          {t('modal.bpType.tab.eu')}
        </li>
        <li
          className={cx(liClassNames, {
            'border-global-neuchatel-50 z-10': mode === Mode.US,
            'border-background-base-primary text-text-tertiary': mode !== Mode.US,
          })}
          onClick={setUsMode}
        >
          {t('modal.bpType.tab.us')}
        </li>
      </ul>

      {mode === Mode.EU ? <AktiiaStatusEuImage /> : <AktiiaStatusUsImage />}

      <p className="mt-4 typography-paragraph-3 text-text-secondary">{t(`modal.bpType.note.${mode}`)}</p>
    </Modal>
  );
};
